import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Supplier } from "../../components/Suppliers/types/supplier";

export interface SupplierState {
  supplierList: Supplier[];
  supplierDetail?: Supplier;
}

export const initialSupplierState: SupplierState = {
  supplierList: []
};

export const supplierSlice = createSlice({
  name: "suppliers",
  initialState: initialSupplierState,
  reducers: {
    setSupplierList: (state, action: PayloadAction<Supplier[]>) => {
      state.supplierList = action.payload;
    },

    resetSupplierList: (state) => {
      state.supplierList = initialSupplierState.supplierList;
    },

    addSupplierList: (state, action: PayloadAction<Supplier[]>) => {
      state.supplierList = [...state.supplierList, ...action.payload];
    },

    setSupplierDetail: (state, action: PayloadAction<Supplier>) => {
      state.supplierDetail = action.payload;
    },

    resetSupplierDetail: (state) => {
      state.supplierDetail = initialSupplierState.supplierDetail;
    },

    addSupplier: (state, action: PayloadAction<Supplier>) => {
      state.supplierList = [...state.supplierList, action.payload];
    },

    updateSupplier: (state, action: PayloadAction<Supplier>) => {
      const index = state.supplierList.findIndex(
        (s) => s.id === action.payload.id
      );
      if (index !== -1) {
        state.supplierList[index] = action.payload;
      }
    },

    deleteSupplier: (state, action: PayloadAction<string>) => {
      state.supplierList = state.supplierList.filter(
        (s) => s.id !== action.payload
      );
    }
  }
});

export const {
  setSupplierList,
  setSupplierDetail,
  resetSupplierList,
  addSupplierList,
  resetSupplierDetail,
  addSupplier,
  updateSupplier,
  deleteSupplier
} = supplierSlice.actions;

export default supplierSlice.reducer;
